import type { EventCard } from './types'

/**
 * การ์ดเหตุการณ์ — แบ่งเป็น
 *  • scope 'global'   = เหตุการณ์ไซไฟระดับโลก กระทบผู้เล่นทุกคน
 *  • scope 'personal' = โทษ/บัฟรายตัว ติดอยู่กับคนที่จั่วเท่านั้น
 * โทษที่ "กันได้ด้วยโล่พลังงาน" = การ์ด tone 'bad' ที่ scope 'personal'
 */
export const EVENT_CARDS: EventCard[] = [
  /* ================= เหตุการณ์ระดับโลก ================= */
  {
    id: 'e-solarflare',
    scope: 'global',
    tone: 'bad',
    title: 'พายุสุริยะถล่มระบบธนาคาร',
    emoji: '🌞',
    text: 'เซิร์ฟเวอร์ธนาคารกลางไหม้ ดอกเบี้ยพุ่งกระฉูด ทุกคนโดนเรียกเก็บดอกเบี้ยพิเศษจากหนี้สินทั้งหมด 2 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'debtSurge', label: 'ดอกเบี้ยพุ่ง +3%', emoji: '🌞', magnitude: 0.03, turnsLeft: 2, good: false },
      },
    ],
  },
  {
    id: 'e-aitakeover',
    scope: 'global',
    tone: 'bad',
    title: 'AI แย่งงานมนุษย์',
    emoji: '🤖',
    text: 'โมเดลใหม่ทำงานแทนคนได้ 80% ของงานออฟฟิศ เงินเดือนทุกคนหาย 30% เป็นเวลา 3 รอบ — นี่คือเหตุผลที่ต้องมี Passive Income',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'salaryMult', label: 'เงินเดือน −30%', emoji: '🤖', magnitude: 0.7, turnsLeft: 3, good: false },
      },
    ],
  },
  {
    id: 'e-heatwave',
    scope: 'global',
    tone: 'bad',
    title: 'คลื่นความร้อนขั้นวิกฤต',
    emoji: '🌡️',
    text: 'อุณหภูมิโดมพุ่ง 48°C คนย้ายออกจากเมือง ค่าเช่าทุกโฉนดหาย 25% เป็นเวลา 2 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'rentEarnMult', label: 'ค่าเช่า −25%', emoji: '🌡️', magnitude: 0.75, turnsLeft: 2, good: false },
      },
    ],
  },
  {
    id: 'e-cryptocrash',
    scope: 'global',
    tone: 'bad',
    title: 'ฟองสบู่คริปโตแตก',
    emoji: '💥',
    text: 'MOONDUST ร่วง 70% ในคืนเดียว มูลค่าสินทรัพย์คริปโตของทุกคนหายครึ่ง',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'marketCrash', label: 'คริปโตพัง', emoji: '💥', magnitude: 0.5, turnsLeft: 1, good: false },
      },
    ],
  },
  {
    id: 'e-aliens',
    scope: 'global',
    tone: 'good',
    title: 'มนุษย์ต่างดาวติดต่อมา!',
    emoji: '🛸',
    text: 'เอเลี่ยนอยากมาเที่ยวโลก เศรษฐกิจบูมสุดขีด ค่าเช่าทุกโฉนดคูณสองเป็นเวลา 2 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'rentEarnMult', label: 'ค่าเช่า x2', emoji: '🛸', magnitude: 2, turnsLeft: 2, good: true },
      },
    ],
  },
  {
    id: 'e-nanovirus',
    scope: 'global',
    tone: 'bad',
    title: 'ไวรัสนาโนระบาด',
    emoji: '🦠',
    text: 'นาโนบอทกลายพันธุ์ ทุกคนต้องจ่ายค่าฉีดวัคซีนนาโน ฿18,000',
    effects: [{ t: 'cash', amount: -18_000 }],
  },
  {
    id: 'e-blackout',
    scope: 'global',
    tone: 'bad',
    title: 'ไฟดับทั้งเมือง 72 ชั่วโมง',
    emoji: '🔌',
    text: 'โรงไฟฟ้าฟิวชันดับ สาธารณูปโภคเก็บค่าเช่าไม่ได้ 3 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'utilityOff', label: 'สาธารณูปโภคดับ', emoji: '🔌', magnitude: 0, turnsLeft: 3, good: false },
      },
    ],
  },
  {
    id: 'e-goldrain',
    scope: 'global',
    tone: 'good',
    title: 'ฝนดาวตกทองคำ',
    emoji: '🌠',
    text: 'อุกกาบาตแร่หายากตกใส่เมือง ทุกคนเก็บขายได้ ฿35,000',
    effects: [{ t: 'cash', amount: 35_000 }],
  },
  {
    id: 'e-boom',
    scope: 'global',
    tone: 'good',
    title: 'ยุคทองของเทคโนโลยี',
    emoji: '🚀',
    text: 'ตลาดทุนเดือด ทุกคนได้กระแสเงินสดจากสินทรัพย์เพิ่ม 50% เป็นเวลา 3 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'passiveMult', label: 'Passive +50%', emoji: '🚀', magnitude: 1.5, turnsLeft: 3, good: true },
      },
    ],
  },
  {
    id: 'e-recession',
    scope: 'global',
    tone: 'bad',
    title: 'เศรษฐกิจถดถอยครั้งใหญ่',
    emoji: '📉',
    text: 'ทุกคนรับ Payday แค่ครึ่งเดียวเป็นเวลา 2 รอบ ใครมีหนี้เยอะจะรู้สึกทันที',
    effects: [
      {
        t: 'effect',
        scope: 'global',
        effect: { kind: 'paydayMult', label: 'Payday ครึ่งเดียว', emoji: '📉', magnitude: 0.5, turnsLeft: 2, good: false },
      },
    ],
  },
  {
    id: 'e-robotax',
    scope: 'global',
    tone: 'bad',
    title: 'ภาษีหุ่นยนต์ย้อนหลัง',
    emoji: '🧾',
    text: 'รัฐบาลเรียกเก็บภาษีหุ่นยนต์ย้อนหลัง 8% ของสินทรัพย์รวมจากทุกคน',
    effects: [{ t: 'cashPct', pct: -0.08, base: 'assets' }],
  },
  {
    id: 'e-ubi',
    scope: 'global',
    tone: 'good',
    title: 'รัฐแจกเงินดิจิทัลถ้วนหน้า',
    emoji: '🎁',
    text: 'นโยบายรายได้พื้นฐาน ทุกคนรับ ฿25,000 ทันที',
    effects: [{ t: 'cash', amount: 25_000 }],
  },
  {
    id: 'e-timequake',
    scope: 'global',
    tone: 'weird',
    title: 'แผ่นดินไหวเวลา',
    emoji: '⏳',
    text: 'เวลาบิดตัว! ทุกคนถูกดูดไปช่องสุ่มบนกระดาน (ไม่ได้รับ Payday)',
    effects: [{ t: 'move', to: 'random' }],
  },

  /* ================= โทษ & บัฟรายตัว ================= */
  {
    id: 'e-cryo',
    scope: 'personal',
    tone: 'bad',
    title: 'โดนแช่แข็งไครโอ',
    emoji: '🧊',
    text: 'แคปซูลนอนของคุณค้าง! หลับต่ออีกหนึ่งเดือน — ข้ามตาถัดไป',
    effects: [{ t: 'skip', turns: 1 }],
  },
  {
    id: 'e-blackhole',
    scope: 'personal',
    tone: 'weird',
    title: 'ตกหลุมดำจิ๋ว',
    emoji: '🕳️',
    text: 'มีคนทดลองฟิสิกส์ในโรงรถ คุณถูกดูดไปโผล่อีกฝั่งของกระดาน',
    effects: [{ t: 'move', to: 'random' }],
  },
  {
    id: 'e-abduct',
    scope: 'personal',
    tone: 'bad',
    title: 'เอเลี่ยนลักพาตัว',
    emoji: '👽',
    text: 'ยานลำหนึ่งเข้าใจผิดว่าคุณเป็นตัวอย่างวิจัย ตำรวจไซเบอร์พาไปสถานีกักกัน',
    effects: [{ t: 'quarantine' }],
  },
  {
    id: 'e-hacked',
    scope: 'personal',
    tone: 'bad',
    title: 'บัญชีถูกแฮก',
    emoji: '🔓',
    text: 'แฮกเกอร์ล็อกกระเป๋าเงินคุณ ห้ามซื้อสินทรัพย์ใด ๆ 2 รอบ และเสียเงิน ฿20,000',
    effects: [
      { t: 'cash', amount: -20_000 },
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'noBuy', label: 'ซื้อไม่ได้', emoji: '🔓', magnitude: 0, turnsLeft: 2, good: false },
      },
    ],
  },
  {
    id: 'e-magnetic',
    scope: 'personal',
    tone: 'bad',
    title: 'สนามแม่เหล็กรบกวน',
    emoji: '🧲',
    text: 'ลูกเต๋าควอนตัมของคุณเพี้ยน ทอยได้สูงสุดแค่ 3 แต้มต่อลูก เป็นเวลา 2 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'diceCap', label: 'เต๋าตันที่ 3', emoji: '🧲', magnitude: 3, turnsLeft: 2, good: false },
      },
    ],
  },
  {
    id: 'e-signal',
    scope: 'personal',
    tone: 'bad',
    title: 'สัญญาณดาวเทียมขาด',
    emoji: '📵',
    text: 'ระบบเก็บเงินอัตโนมัติล่ม คุณไม่ได้รับ Passive Income ในรอบถัดไป',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'passiveMult', label: 'ไม่มี Passive', emoji: '📵', magnitude: 0, turnsLeft: 1, good: false },
      },
    ],
  },
  {
    id: 'e-timeloop',
    scope: 'personal',
    tone: 'weird',
    title: 'ติดไทม์ลูป',
    emoji: '🌀',
    text: 'คุณเดินย้อนกลับไปยังจุดเดิม! ถอยหลัง 5 ช่อง',
    effects: [{ t: 'move', to: 'back', steps: 5 }],
  },
  {
    id: 'e-clone',
    scope: 'personal',
    tone: 'bad',
    title: 'โคลนนิ่งผิดพลาด',
    emoji: '👥',
    text: 'ร่างโคลนของคุณใช้บัตรเครดิตหมดวงเงิน จ่าย ฿45,000',
    effects: [{ t: 'cash', amount: -45_000 }],
  },
  {
    id: 'e-jetpack',
    scope: 'personal',
    tone: 'good',
    title: 'ได้เจ็ตแพ็ครุ่นใหม่',
    emoji: '🎒',
    text: 'เดินเร็วขึ้น! ทอยเต๋าเพิ่มอีกหนึ่งลูกเป็นเวลา 3 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'extraDie', label: 'เต๋า 3 ลูก', emoji: '🎒', magnitude: 1, turnsLeft: 3, good: true },
      },
    ],
  },
  {
    id: 'e-shield',
    scope: 'personal',
    tone: 'good',
    title: 'โล่พลังงานส่วนตัว',
    emoji: '🛡️',
    text: 'ซื้อโล่จากตลาดมืด กันโทษไซไฟรายตัวได้ 1 ครั้ง',
    effects: [{ t: 'shield', amount: 1 }],
  },
  {
    id: 'e-crystal',
    scope: 'personal',
    tone: 'good',
    title: 'คริสตัลควอนตัม',
    emoji: '💎',
    text: 'คริสตัลขยายสัญญาณค่าเช่า คุณเก็บค่าเช่าได้ x1.5 เป็นเวลา 3 รอบ',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'rentEarnMult', label: 'ค่าเช่า x1.5', emoji: '💎', magnitude: 1.5, turnsLeft: 3, good: true },
      },
    ],
  },
  {
    id: 'e-insurance',
    scope: 'personal',
    tone: 'good',
    title: 'เคลมประกันสำเร็จ',
    emoji: '📑',
    text: 'ยานลอยของคุณถูกอุกกาบาตชน แต่ประกันจ่ายเต็ม รับ ฿60,000',
    effects: [{ t: 'cash', amount: 60_000 }],
  },
  {
    id: 'e-baby',
    scope: 'personal',
    tone: 'weird',
    title: 'มีลูก! 👶',
    emoji: '👶',
    text: 'ยินดีด้วย! ค่าเลี้ยงดูบุตรถูกเพิ่มเข้างบรายจ่ายทุกเดือน — บทเรียนข้อแรกของ Cashflow',
    effects: [{ t: 'child' }],
  },
  {
    id: 'e-doodad-phone',
    scope: 'personal',
    tone: 'bad',
    title: 'รายจ่ายจุกจิก: มือถือรุ่นใหม่',
    emoji: '📱',
    text: 'ทนไม่ได้ ต้องซื้อ NeuraPhone 17 Pro Max จ่าย ฿32,000',
    effects: [{ t: 'cash', amount: -32_000 }],
  },
  {
    id: 'e-doodad-vacation',
    scope: 'personal',
    tone: 'bad',
    title: 'รายจ่ายจุกจิก: ทริปดวงจันทร์',
    emoji: '🌗',
    text: 'เห็นโปรลดราคาแล้วห้ามใจไม่ได้ จ่าย ฿55,000',
    effects: [{ t: 'cash', amount: -55_000 }],
  },
  {
    id: 'e-doodad-pet',
    scope: 'personal',
    tone: 'bad',
    title: 'รายจ่ายจุกจิก: หุ่นยนต์สัตว์เลี้ยง',
    emoji: '🐈',
    text: 'น่ารักมาก แต่ค่าแบตเตอรี่แพงมาก จ่าย ฿24,000',
    effects: [{ t: 'cash', amount: -24_000 }],
  },
  {
    id: 'e-bonus',
    scope: 'personal',
    tone: 'good',
    title: 'โบนัสพิเศษจากบริษัท',
    emoji: '💰',
    text: 'หัวหน้าประทับใจผลงานคุณ รับโบนัสเท่ากับเงินเดือน 1 เดือน',
    effects: [{ t: 'cashPct', pct: 1, base: 'salary' }],
  },
  {
    id: 'e-audit',
    scope: 'personal',
    tone: 'bad',
    title: 'สรรพากรตรวจสอบย้อนหลัง',
    emoji: '🔍',
    text: 'จ่ายภาษี 12% ของสินทรัพย์รวม',
    effects: [{ t: 'cashPct', pct: -0.12, base: 'assets' }],
  },
  {
    id: 'e-lottery',
    scope: 'personal',
    tone: 'good',
    title: 'ถูกลอตเตอรีควอนตัม',
    emoji: '🎰',
    text: 'ถูกทุกใบในทุกจักรวาลขนาน! เก็บกองกลางไปทั้งหมด',
    effects: [{ t: 'jackpot' }],
  },
  {
    id: 'e-viral',
    scope: 'personal',
    tone: 'good',
    title: 'คลิปคุณไวรัล',
    emoji: '🔥',
    text: 'ทุกคนอยากร่วมงานกับคุณ ผู้เล่นอื่นจ่ายค่าที่ปรึกษาให้คุณคนละ ฿15,000',
    effects: [{ t: 'eachPays', amount: 15_000 }],
  },
  {
    id: 'e-party',
    scope: 'personal',
    tone: 'bad',
    title: 'จัดปาร์ตี้ลอยฟ้า',
    emoji: '🎉',
    text: 'คุณเลี้ยงทุกคน! จ่ายผู้เล่นอื่นคนละ ฿12,000',
    effects: [{ t: 'payEach', amount: 12_000 }],
  },
  {
    id: 'e-teleport',
    scope: 'personal',
    tone: 'weird',
    title: 'เทเลพอร์ตผิดพิกัด',
    emoji: '🌌',
    text: 'เครื่องเทเลพอร์ตส่งคุณไปโผล่ที่ท่าอวกาศพักผ่อน — แต่ก็ได้เก็บกองกลางนะ',
    effects: [{ t: 'move', to: 20 }],
  },
  {
    id: 'e-mentor',
    scope: 'personal',
    tone: 'good',
    title: 'เจอเมนเทอร์พ่อรวย',
    emoji: '🎩',
    text: 'ได้บทเรียนเรื่องเลเวอเรจแบบเข้าเส้น! รอบหน้า Payday ของคุณคูณสอง',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'paydayMult', label: 'Payday x2', emoji: '🎩', magnitude: 2, turnsLeft: 1, good: true },
      },
    ],
  },
  {
    id: 'e-repo',
    scope: 'personal',
    tone: 'bad',
    title: 'ยานถูกยึด',
    emoji: '🪝',
    text: 'ผ่อนไม่ทัน ไฟแนนซ์ยึดยานลอย คุณต้องเดินเท้า — ข้ามตาถัดไป และจ่าย ฿15,000',
    effects: [
      { t: 'cash', amount: -15_000 },
      { t: 'skip', turns: 1 },
    ],
  },
  {
    id: 'e-glitch',
    scope: 'personal',
    tone: 'weird',
    title: 'กระดานกลิตช์',
    emoji: '🎛️',
    text: 'ระบบนำทางเพี้ยน ตาถัดไปคุณจะเดินถอยหลังแทน',
    effects: [
      {
        t: 'effect',
        scope: 'self',
        effect: { kind: 'reverse', label: 'เดินถอยหลัง', emoji: '🎛️', magnitude: 0, turnsLeft: 1, good: false },
      },
    ],
  },
  {
    id: 'e-gold',
    scope: 'personal',
    tone: 'good',
    title: 'ขุดเจอแร่หายากใต้บ้าน',
    emoji: '🪙',
    text: 'ใต้บ้านคุณมีสายแร่นีโอเดียมเมียม ขายได้ ฿90,000',
    effects: [{ t: 'cash', amount: 90_000 }],
  },
]

export const EVENT_BY_ID = new Map(EVENT_CARDS.map((c) => [c.id, c]))
